import { getTeamsBySeasonV2, getPlayersBySeason } from '@/utils/api/teams';
import axios from 'axios';

function getDefaultPlayingAs() {
  return [1, 2];
}
function getDefaultTimeSections() {
  return [1, 2, 3, 4, 5, 6];
}
function getDefaultFieldSections() {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
}
function getDefaultFieldSectors() {
  return [
    { num: 13, status: true },
    { num: 14, status: true },
    { num: 15, status: true },
    { num: 16, status: true },
    { num: 9, status: true },
    { num: 10, status: true },
    { num: 11, status: true },
    { num: 12, status: true },
    { num: 5, status: true },
    { num: 6, status: true },
    { num: 7, status: true },
    { num: 8, status: true },
    { num: 1, status: true },
    { num: 2, status: true },
    { num: 3, status: true },
    { num: 4, status: true },
  ];
}

export default {
  namespaced: true,
  state: {
    positions: [
      { name: 'Portero' },
      { name: 'Defensa central' },
      { name: 'Lateral por izquierda' },
      { name: 'Lateral por derecha' },
      { name: 'Volante por izquierda' },
      { name: 'Volante por derecha' },
      { name: 'Volante defensivo' },
      { name: 'Volante ofensivo' },
      { name: 'Delantero' },
      { name: 'Desconocida' },
    ],
    tournamentID: null,
    seasonID: null,
    teamID: null,
    playerID: null,
    teams: [],
    teamsMobile: [],
    players: [],
    playersByTeam: [],
    playersByTeamMobile: [],
    tournaments: [],
    player: null,
    retroSeason: null,
    retroTournament: {
      seasons: [],
    },
    lastSeason: null,
    isModalOpen: false,
    isModalCreatePlayListOpen: false,
    modalSectionSelected: 0,
    modalInitialState: {
      seasonId: 0,
      tournaments: [], // torneos para el video reproductor
      isFeaturedPlayers: false, // para indicar si es de la seccion jugadores destacados
      mainSectionType: 1, // 1 = videoplayer, 2 = my playlists
      playListType: 1, // 1 = partidos, 2 = jugadores, 3 = equipos
      gameIds: null, // array de id de partido, en caso de no ser necesario dejar en null
      playerIds: [], // ids de jugador, en caso de no ser necesario dejar array vacio
      goalkeeperIds: [],
      categoryIds: [], // son los ids de las categorias a ser pedidas
      teamId: 0, // id de equipo, en caso de no ser necesario dejar en cero 0
      matchResult: [1, 2, 3], // 1 = gana, 2 = pierde, 3 = empate.
      categorySingleName: '', // nombre individual para cada jugada en la lista
      avoidCategorySingleName: false, // para indicar casos en los que no se debe tomar en cuenta categorySingleName
      currentPlayIndex: 0,
      playData: {
        // objeto con la informacion de la jugada seleccionada o null
        /**
         * Objeto de la jugada seleccionada, en casos como chalkboard o porteria de goles,
         * puede tener mas o menos campos dependiendo el origen, por ejemplo las jugadas en el
         * componente {@see module:SoccerChalkboard.computed.preparedPlays}.
         * Los campos disponibles de cada tipo de jugada estan en:
         * {@see module:teamGoalPlayIndexes}
         * {@see module:teamStatsPlayIndexes}
         * {@see module:playerGoalPlayIndexes}
         * {@see module:playerStatsPlayIndexes}
         */
      },
      lastClashedGameId: null, // only for last clashes in bets
      tournamentsLastClashes: null, // only for last clashes in bets
      advancedFilter: {
        // valores para filtro avanzado, en caso de no ser cesario dejar en null
        playListTitle: '',
        mainCategoryId: 0, // id de categoria seleccionada
        // subCategoryIds: [],               // ids de subcategorias activas
        playingAs: [1, 2], // array 1  local, 2 visitante, ambos todos
        timeSections: [1, 2, 3, 4, 5, 6], // 1 = 0-15, 2 = 16-30, 3 = 31-45, 4 = 46-60, 5 = 61-75, 6 = 76-90,
        coordinatePoint: 0,
        fieldSections: [
          // secciones de la cancha seleccionadas
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
        ],
      },
      objectPlaySync: null, // sync play seconds between media players { numberPlayId, numberCurrentTime }
    },
    currentPlayerQueue: [],
    playlistIndex: 0,
    playlistGameId: 0,
    playerType: 1,
    advancedFilterCategories: {
      games: [],
      player: [],
      team: [],
      goalkeeper: [],
      isEmpty: true,
    },
    advancedFilterCategoriesRaw: [],
    advancedFilter: {
      // valores para filtro avanzado, en caso de no ser cesario dejar en null
      playListTitle: '',
      mainCategoryId: 0, // id de categoria seleccionada
      subCategoryIds: [], // ids de subcategorias activas
      playingAs: getDefaultPlayingAs(), // array 1  local, 2 visitante, ambos todos
      timeSections: getDefaultTimeSections(), // 1 = 0-15, 2 = 16-30, 3 = 31-45, 4 = 46-60, 5 = 61-75, 6 = 76-90,
      coordinatePoint: 0,
      // secciones de la cancha seleccionadas
      fieldSections: getDefaultFieldSections(),
      requiresRivalTransform: false,
    },
    advancedFilterBackUp: {},
    applyAdvancedFilterCounter: 0,
    selectedSubcategoryIds: [],
    // plays for my playlist section
    currentPlaylistPlays: [],
    objectMediaData: null,
  },
  getters: {
    getCurrentPlayerQueue(state) {
      return state.currentPlayerQueue;
    },
    getModalSectionSelected(state) {
      return state.modalSectionSelected;
    },
    hasPlayerPositionId(state) {
      return !!state.player.positionId;
    },
    isPlayerGoalkeeper: state => {
      if (state.player) {
        return state.player.position_name === 'Portero' || state.player.positionId === 1;
      }
      return false;
    },
    currentPlayerQueueByGames(state) {
      let gameIndex = 0;
      let playsByGames = null;
      if (state.currentPlayerQueue && state.currentPlayerQueue.length) {
        if (state.currentPlayerQueue[0].isPlaySeeker) {
          return [];
        } else if (state.currentPlayerQueue[0].booleanIsFullGame) {
          playsByGames = state.currentPlayerQueue.reduce((accumulator, play, index) => {
            play.index = index;
            const gameAux = accumulator.get(play.gameId);
            if (gameAux) {
              gameAux.finalPlayIndex = index;
              gameAux.plays.push(play);
            } else {
              accumulator.set(play.gameId, {
                ...play.objectGame,
                booleanIsFullGame: true,
                initialPlayIndex: index,
                finalPlayIndex: index,
                isExpanded: index === 0,
                plays: [play],
                gameIndex,
              });
              gameIndex++;
            }
            return accumulator;
          }, new Map());
        } else {
          playsByGames = state.currentPlayerQueue.reduce((accumulator, play, index) => {
            play.index = index;
            const gameAux = accumulator.get(play.gameId);
            if (gameAux) {
              gameAux.finalPlayIndex = index;
              gameAux.plays.push(play);
            } else {
              accumulator.set(play.gameId, {
                ...play.game,
                initialPlayIndex: index,
                finalPlayIndex: index,
                isExpanded: index === 0,
                plays: [play],
                gameIndex,
              });
              gameIndex++;
            }
            return accumulator;
          }, new Map());
        }
      } else {
        return [];
      }
      return Array.from(playsByGames.values());
    },
    getPlayers: state => {
      return state.playersByTeam;
    },
    getPlayersMobile: state => {
      return state.playersByTeamMobile;
    },
    getTeams: state => {
      return state.teams;
    },
    getTeamsMobile: state => {
      return state.teamsMobile;
    },
    getTeamId: state => {
      return state.teamID;
    },
    getIsModalCreatePlayListOpen: state => {
      return state.isModalCreatePlayListOpen;
    },
    getTournamentId: state => {
      return state.tournamentID;
    },
    getSeasonId: state => {
      return state.seasonID;
    },
    getSeasonIdOnly: state => {
      return state.seasonID ? state.seasonID.id : null;
    },
    getPlayerId: state => {
      return state.playerID;
    },
    playersByTeam: state => {
      return state.players.reduce((accumulator, player) => {
        const playerAux = {
          id: player.player_id,
          name: player.player_name,
          shortName: player.shortName,
          photo: player.player_photo,
          teamId: player.team_id,
          positionId: player.position_id,
        };
        const teamPlayers = accumulator.get(player.team_id);
        if (teamPlayers) {
          teamPlayers.push(playerAux);
        } else {
          accumulator.set(player.team_id, [playerAux]);
        }
        return accumulator;
      }, new Map());
    },
    seasonPlayers: state => {
      return state.players.reduce((accumulator, player) => {
        accumulator.set(player.player_id, {
          id: player.player_id,
          name: player.player_name,
          shortName: player.shortName,
          photo: player.player_photo,
          teamId: player.team_id,
          positionId: player.position_id,
        });
        return accumulator;
      }, new Map());
    },
    selectedTournament: state => {
      return state.tournamentID ? state.tournaments.find(tournament => tournament._id === state.tournamentID.id) : null;
    },
  },
  mutations: {
    setObjectMediaData(state, objectMediaData) {
      state.objectMediaData = objectMediaData;
    },
    setCurrentPlaylistPlays(state, currentPlaylistPlays) {
      state.currentPlaylistPlays = currentPlaylistPlays;
    },
    setSelectedSubcategoryIds(state, selectedSubcategoryIds) {
      state.selectedSubcategoryIds = selectedSubcategoryIds;
    },
    increaseApplyAdvancedFilterCounterByOne(state) {
      state.applyAdvancedFilterCounter += state.applyAdvancedFilterCounter + 1;
    },
    resetAdvancedFilter(state) {
      state.advancedFilter = {
        playListTitle: '',
        mainCategoryIds: [],
        subCategoryIds: [],
        playingAs: getDefaultPlayingAs(),
        timeSections: getDefaultTimeSections(),
        coordinatePoint: 0,
        fieldSectors: getDefaultFieldSectors(),
        requiresRivalTransform: false,
      };
    },
    setAdvancedFilterBackUp(state) {
      state.advancedFilterBackUp = {
        playListTitle: state.advancedFilter.playListTitle || '',
        mainCategoryIds: state.advancedFilter.mainCategoryIds,
        subCategoryIds: [],
        playingAs: state.advancedFilter.playingAs ? [...state.advancedFilter.playingAs] : getDefaultPlayingAs(),
        timeSections: state.advancedFilter.timeSections
          ? [...state.advancedFilter.timeSections]
          : getDefaultTimeSections(),
        coordinatePoint: state.advancedFilter.coordinatePoint || 0,
        fieldSectors: state.advancedFilter.fieldSectors.map(fieldSector => {
          return { ...fieldSector };
        }),
        requiresRivalTransform: state.advancedFilter.requiresRivalTransform,
      };
    },
    restoreAdvancedFilterFromBackUp(state) {
      state.advancedFilter = {
        playListTitle: state.advancedFilterBackUp.playListTitle || '',
        mainCategoryIds: state.advancedFilterBackUp.mainCategoryIds,
        subCategoryIds: [],
        playingAs: state.advancedFilterBackUp.playingAs ? state.advancedFilterBackUp.playingAs : getDefaultPlayingAs(),
        timeSections: state.advancedFilterBackUp.timeSections
          ? state.advancedFilterBackUp.timeSections
          : getDefaultTimeSections(),
        coordinatePoint: state.advancedFilterBackUp.coordinatePoint || 0,
        fieldSectors: state.advancedFilterBackUp.fieldSectors.map(fieldSector => {
          return { ...fieldSector };
        }),
        requiresRivalTransform: state.advancedFilterBackUp.requiresRivalTransform,
      };
    },
    setAdvancedFilter(state, advancedFilter) {
      const advancedFilterAux = advancedFilter || {};
      state.advancedFilter = {
        playListTitle: advancedFilterAux.playListTitle || '',
        mainCategoryIds: [...advancedFilter.mainCategoryIds] || [],
        subCategoryIds: [],
        playingAs: advancedFilterAux.playingAs ? [...advancedFilterAux.playingAs] : getDefaultPlayingAs(),
        timeSections: advancedFilterAux.timeSections ? [...advancedFilterAux.timeSections] : getDefaultTimeSections(),
        coordinatePoint: advancedFilterAux.coordinatePoint || 0,
        fieldSectors: getDefaultFieldSectors(),
        requiresRivalTransform: advancedFilter.requiresRivalTransform || false,
      };
      if (advancedFilterAux.fieldSections && advancedFilterAux.fieldSections.length) {
        state.advancedFilter.fieldSectors.forEach(fieldSector => {
          if (advancedFilterAux.isFromStatisticField) {
            fieldSector.status = advancedFilterAux.fieldSections.includes(fieldSector.num);
          } else {
            fieldSector.status = advancedFilterAux.fieldSections.includes(fieldSector.num);
          }
        });
      }
    },
    setAdvancedFilterCategoriesRaw(state, advancedFilterCategoriesRaw = []) {
      state.advancedFilterCategoriesRaw = advancedFilterCategoriesRaw;
    },
    setAdvancedFilterCategories(state, advancedFilterCategories = {}) {
      state.advancedFilterCategories = advancedFilterCategories;
    },
    setPlayerType(state, playerType) {
      state.playerType = playerType;
    },
    setPlaylistGameId(state, playlistGameId) {
      state.playlistGameId = playlistGameId;
    },
    setCurrentPlayerQueue(state, currentPlayerQueue) {
      state.currentPlayerQueue = currentPlayerQueue;
    },
    setPlaylistIndex(state, { playlistIndex }) {
      state.playlistIndex = playlistIndex;
    },
    setModalSectionSelected(state, modalSelectedSection = 0) {
      state.modalSectionSelected = modalSelectedSection;
    },
    setIsModalOpen(state, isModalOpen) {
      state.isModalOpen = isModalOpen;
    },
    setIsModalCreatePlayListOpen(state, isModalOpen) {
      state.isModalCreatePlayListOpen = isModalOpen;
    },
    setModalInitialState(state, modalInitialState) {
      state.modalInitialState = modalInitialState;
    },
    setLastSeason(state, lastSeason) {
      state.lastSeason = lastSeason;
    },
    setRetroTournament(state, retroTournament) {
      state.retroTournament = retroTournament;
    },
    setRetroSeason(state, retroSeason) {
      state.retroSeason = retroSeason;
    },
    setTournaments(state, tournaments) {
      tournaments.forEach(tournament => {
        tournament.seasons.forEach((season, index) => {
          season.index = index;
        });
      });
      state.tournaments = tournaments;
    },
    setPlayersByTeam(state, id) {
      state.playersByTeam = id;
    },
    resetPlayer(state) {
      state.playerID = null;
    },
    setPlayersByTeamMobile(state, id) {
      state.playersByTeamMobile = id;
    },
    setPlayers(state, players) {
      state.players = players;
    },
    setTournament(state, id) {
      state.tournamentID = id;
    },
    setSeason(state, id) {
      state.seasonID = id;
    },
    setTeam(state, id) {
      state.teamID = id;
    },
    setPlayer(state, player) {
      state.player = player;
      state.playerID = player ? player.player_id || player.id : null;
    },
    setPlayerId(state, playerId) {
      state.playerID = playerId;
    },
    setTeams(state, teams) {
      state.teams = teams;
    },
    setTeamsMobile(state, teams) {
      state.teamsMobile = teams;
    },
  },
  actions: {
    async fetchTournaments({ commit }) {
      try {
        const { data } = await axios.get('https://i90k4l74ik.execute-api.us-east-2.amazonaws.com/prod/tournaments');
        commit('setTournaments', data);
      } catch (e) {
        throw new Error(e);
      }
    },
    async getPlayersByTeam({ commit, state }) {
      let position = 0;
      let playersArray = {};
      let playersMobileArray = {};
      const playersByTeam = state.players.filter(player => player.team_id === state.teamID);
      if (playersByTeam.length > 0) {
        for (let index = 0; index < playersByTeam.length; index++) {
          let indexInit = index;
          playersArray[indexInit] = [];
          let key =
            index + 1 > 6
              ? index + 1 > 12
                ? index + 1 > 18
                  ? index + 1 > 24
                    ? index + 1 > 30
                      ? index + 1 > 36
                        ? index + 1 > 42
                          ? index + 1 > 42
                          : index + 1 - 36
                        : index + 1 - 30
                      : index + 1 - 24
                    : index + 1 - 18
                  : index + 1 - 12
                : index + 1 - 6
              : index + 1;
          playersByTeam[indexInit].position_name = state.positions[playersByTeam[indexInit].position_id - 1].name;
          playersArray[indexInit]['index'] = key;
          let dataNamePlayer = playersByTeam[indexInit].player_name.split(',');
          playersArray[indexInit]['data'] = playersByTeam[indexInit];
          playersArray[indexInit]['name'] = dataNamePlayer[0];
          playersArray[indexInit]['surname'] = dataNamePlayer[1];

          let ageDifMs = Date.now() - new Date(playersByTeam[indexInit].dob);
          let ageDate = new Date(ageDifMs); // miliseconds from epoch

          playersByTeam[indexInit].dob = Math.abs(ageDate.getUTCFullYear() - 1970);

          if (key === 1) {
            position++;
            playersMobileArray[position] = [];
            playersMobileArray[position].push(playersArray[indexInit]);
          } else {
            playersMobileArray[position].push(playersArray[indexInit]);
          }
        }
        commit('setPlayersByTeamMobile', playersMobileArray);
        commit('setPlayersByTeam', playersArray);
      }
    },

    async getPlayersBySeasons({ commit, getters }, payload) {
      try {
        const response = await getPlayersBySeason({
          seasonId: payload && payload.seasonId ? payload.seasonId : getters.selectedTournament.seasons[0].id,
        });
        response.data.players.forEach(player => {
          const [lastName, name] = player.player_name.split(',');
          const lastNameArr = lastName.split(' ');
          let lastNameShort = '';
          for (const word of lastNameArr) {
            lastNameShort += ` ${word}`;
            if (word.length > 3) {
              break;
            }
          }
          player.shortName = name && lastName ? `${name.trim().charAt(0)}.${lastNameShort}` : '';
        });
        commit('setPlayers', response.data.players);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getTeamsBySeasons({ commit, state }, payload = { seasonId: 0 }) {
      try {
        var position = 0;
        var teamsArray = {};
        var teamsMobileArray = {};
        const teams = await getTeamsBySeasonV2({
          seasonId: payload.seasonId || state.seasonID.id,
        });
        if (teams.data.teams) {
          for (let index = 0; index < teams.data.teams.length; index++) {
            var indexInit = index;
            teamsArray[indexInit] = [];
            var key =
              index + 1 > 6
                ? index + 1 > 12
                  ? index + 1 > 18
                    ? index + 1 > 24
                      ? index + 1 > 30
                        ? index + 1 > 36
                          ? index + 1 > 42
                            ? index + 1 > 42
                            : index + 1 - 36
                          : index + 1 - 30
                        : index + 1 - 24
                      : index + 1 - 18
                    : index + 1 - 12
                  : index + 1 - 6
                : index + 1;

            teamsArray[indexInit]['index'] = key;
            teamsArray[indexInit]['data'] = teams.data.teams[indexInit];
            if (key == 1) {
              position++;
              teamsMobileArray[position] = [];
              teamsMobileArray[position].push(teamsArray[indexInit]);
            } else {
              teamsMobileArray[position].push(teamsArray[indexInit]);
            }
          }
          commit('setTeams', teamsArray);
          commit('setTeamsMobile', teamsMobileArray);
        }
      } catch (e) {
        return Promise.reject(e);
      }
    },
    /**
     * @author Alejandro Martinez
     * @param {Object} payload
     * @param {Array<number>} payload.seasons - seasons ids
     * @return {Promise<{seasonsAndGames: *, seasonsAndTeams: *}|*|undefined>}
     */
    async fetchSeasonsGamesAndTeams(_, payload) {
      try {
        let gamesUrl = 'https://qyyibs1w0d.execute-api.us-west-2.amazonaws.com/prod/calendar/gamesBySeason?';
        // let gamesUrl = 'https://kkd48smit2.execute-api.us-west-2.amazonaws.com/qa/calendar/gamesBySeason?';
        payload.seasons.forEach((seasonId, index) => {
          const prefix = index === 0 ? '' : '&';
          gamesUrl += `${prefix}seasons=${seasonId}`;
        });
        const {
          data: { data, teams },
        } = await axios.get(gamesUrl);
        return { seasonsAndGames: data, seasonsAndTeams: teams };
      } catch (e) {
        throw new Error(e);
      }
    },
  },
};
